<template>
  <scrollbar>
    <div slot="scrollbar" class="main-content" :class="{ 'is-mobile': isMobile }">
      <main-header v-if="topImg"></main-header>
      <div
        :style="{ height: noHeight, padding: noPadding, backgroundImage: `url(${bgImg})` }"
        class="scrollbar-box"
      >
        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cacheComponents">
            <router-view :key="key" />
          </keep-alive>
        </transition>
      </div>
    </div>
  </scrollbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
    MainHeader: () => import('./mainHeader')
  },
  data() {
    return {
      lgPadding: '20px',
      defaultPadding: '5px'
    };
  },
  provide() {
    return {
      getContent: () => this
    };
  },
  computed: {
    ...mapState('app', ['cacheComponents']),
    key() {
      return this.$route.meta.key ? new Date().getTime() : null;
    },
    topImg() {
      return this.$route.meta.headerOptions && this.$route.meta.headerOptions.img;
    },
    bgImg() {
      return this.$route.meta && this.$route.meta.bgImg ? this.$route.meta.bgImg : '';
    },
    noHeight() {
      if (this.topImg) {
        return 'calc(100% - var(--main-header-height))';
      } else {
        return '100%';
      }
    },
    noPadding() {
      if (this.$route.meta.noPadding) {
        return '0';
      } else {
        return window.innerHeight > 1200 ? this.lgPadding : this.defaultPadding;
      }
    }
  },
  methods: {
    setPadding(v) {
      this.defaultPadding = v;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  // min-width: 1280px;
  // min-height: 720px;

  --main-header-height: 60px;
  --main-header-title-fs: 32px;
  --main-header-title-top: 3px;
  --main-header-title-spacing: 2px;
  --main-header-box-fs: 16px;
  --main-header-box-height: 30px;
  --main-header-box-padding: 0 20px;
  --main-header-box-gap: 20px;

  &.is-mobile {
    --main-header-title-fs: 26px;
    --main-header-box-fs: 12px;
    --main-header-box-gap: 5px;
  }

  @media screen and (max-width: 900px) {
    --main-header-height: 40px;
    --main-header-title-fs: 18px;
    --main-header-title-top: 7px;
    --main-header-title-spacing: 1px;
    --main-header-box-fs: 12px;
    --main-header-box-height: 22px;
    --main-header-box-padding: 0 5px;
    --main-header-box-gap: 5px;
  }

  height: 100%;
  .scrollbar-box {
    box-sizing: border-box;
    background-color: var(--layout-app-bg);
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
